export const AGENCIES_PAGE_SIZE = 24;
export const AGENCIES_SEARCH_DEBOUNCE_MS = 200;
